<template>
    <div class="grid-container">
        <div v-for="(solutionItem, index) in solutionOptions" :key="index + 'grid'" class="grid-item" @click="getInfo(solutionItem)">
        <!-- {{ item }} -->
            <img :src="solutionOptions[index].Image.src" alt="">
            <h3>{{solutionItem.name}}</h3>
            <div>
                <p>
                    <a href="">前往了解>></a>
                </p>
            </div>
            
        </div>
    </div>
</template>

<script>
import { solutionOptions } from '@/view/solution.js'
export default {
  name: 'GridComponent',
  data() {
    return {
      // 初始化九宫格的内容
        solutionOptions
    };
  },
  methods: {
    getInfo(val) {
        var rowData = val;
        sessionStorage.setItem("rowData", JSON.stringify(rowData));
        this.$router.push({
            name: "BuildingControl"
        });
    }
  }
};
</script>

<style scoped>
.grid-container {
    display: grid;
    width: 1340px;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px; /* 格子之间的间距 */
    margin: auto;
    margin-top: 50px;
    text-align: left;
  
}
.grid-item  {
    padding: 10px;
    /* background-color: #ebe8e8; */
}

.grid-item  img{
    width: 100%;
    height: 180px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2em;
    margin: auto;
}
.grid-container a {
    font-size: 14px;
    color: #1e7962;
    padding: 0 20px ;
    display: block;
    text-decoration: none;
}
h3 {
    padding: 0 20px;
}
</style>